<app-navbar class="home"></app-navbar>

<div class="landing-wrapper">
  <div class="container">
    <section class="qr-main-wrapper">
      <div class="row">
        <div class="col-xl-8 col-lg-7">
          <div class="qr-category">
            <div class="row">
              <div class="col-xl-3 col-lg-4">
                <p class="mb-2">Static</p>
                <div class="qr-categories">
                  <ng-container *ngFor="let category of static_categories">
                    <a class="category" [routerLink]="'/' + category.href"
                      [class.active]="category.category === selected_category">
                      <i [class]="category.icon"></i> {{category.text}}
                    </a>
                  </ng-container>
                </div>
                <p class="mt-3 mb-2">Dynamic</p>
                <div class="qr-categories">
                  <ng-container *ngFor="let category of dynamic_categories">
                    <a class="category" [routerLink]="'/' + category.href"
                      [class.active]="category.category === selected_category">
                      <i [class]="category.icon"></i> {{category.text}}
                    </a>
                  </ng-container>
                </div>
              </div>
              <div class="col-xl-9 col-lg-8 qr-content-container">
                <ng-container *ngIf="selected_category === all_categories.URL">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_url" (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator?.url_data">
                      <h1 class="mb-1">Enter your URL</h1>
                      <p class="lg">You can track scans with dynamic QR codes, click <a
                          routerLink="/auth/signup">here</a> to get started.</p>
                      <textarea class="form-control" (keydown.enter)="$event.preventDefault(); generateQr()"
                        [class.is-invalid]="(data_form_for_url.controls['url'].errors?.pattern || data_form_for_url.get('url').hasError('required')) && data_form_for_url.get('url').touched"
                        formControlName="url" required maxlength="300" rows="3"
                        placeholder="http://www.my-website.com/..."></textarea>
                      <p class="input-error"
                        *ngIf="data_form_for_url.controls['url'].errors?.pattern && data_form_for_url.get('url').touched">
                        URL is
                        invalid!
                      </p>
                      <p class="input-error"
                        *ngIf="data_form_for_url.get('url').hasError('required') && data_form_for_url.get('url').touched">
                        URL is
                        required!</p>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.BITCOIN">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_bitcoin"
                    (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator && qr_generator.bitcoin_data">
                      <h1 class="mb-3">Bitcoin QR Code</h1>
                      <div class="mb-3">
                        <i class="bi bi-currency-bitcoin me-2"></i>
                        <b>Provide receiver's details</b>
                      </div>
                      <p>Begin by copying the Bitcoin wallet address from the source (messages,
                        emails, websites, and so on) and pasting it into the text area below.
                      </p>

                      <div class="row g-3">

                        <div class="col-lg-12">
                          <label class="form-label">Cryptocurrency</label>
                          <ng-select appearance="outline" formControlName="cryptocurrency" [clearable]="false"
                            [searchable]="false">
                            <ng-option [value]="cryptocurrency.cryptocurrency"
                              *ngFor="let cryptocurrency of cryptocurrencies">
                              {{cryptocurrency.title}}</ng-option>
                          </ng-select>
                        </div>

                        <div class="col-lg-12">
                          <label class="form-label">Amount<span class="text-danger">*</span></label>
                          <input type="number" step="any" formControlName="amount" required class="form-control" min="0"
                            [class.is-invalid]="data_form_for_bitcoin.get('amount').hasError('required') && data_form_for_bitcoin.get('amount').touched">
                          <ng-container *ngIf="data_form_for_bitcoin.get('amount').touched">
                            <p class="input-error" *ngIf="data_form_for_bitcoin.get('amount').hasError('min')">
                              Amount too low!</p>
                            <p class="input-error" *ngIf="data_form_for_bitcoin.get('amount').hasError('required')">
                              Amount is required!</p>
                          </ng-container>
                        </div>

                        <div class="col-lg-12">
                          <label class="form-label">Address<span class="text-danger">*</span></label>
                          <input type="text" formControlName="address" required class="form-control"
                            [class.is-invalid]="data_form_for_bitcoin.get('address').hasError('required') && data_form_for_bitcoin.get('address').touched">
                          <ng-container *ngIf="data_form_for_bitcoin.get('address').touched">
                            <p class="input-error" *ngIf="data_form_for_bitcoin.get('address').hasError('required')">
                              Address is required!</p>
                          </ng-container>
                        </div>
                        <div class="col-lg-12">
                          <label class="form-label">Message</label>
                          <textarea class="form-control" formControlName="message" maxlength="60" rows="2"></textarea>
                        </div>
                      </div>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.WIFI">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_wifi" (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator && qr_generator.wifi_data">
                      <h1 class="mb-3">WiFi QR Code</h1>
                      <div class="mb-3">
                        <i class="bi bi-wifi me-2"></i>
                        <b>Provide WiFi's details</b>
                      </div>
                      <p>Share your WiFi easily with family, friends, guests and customers if you
                        run a business.
                      </p>

                      <div class="t-main-wrapper mb-3">
                        <div class="t-header">
                          <div class="t-title">
                            <label>Hidden network?</label>
                          </div>
                          <div class="toggleWrapper">
                            <input type="checkbox" id="ssl1_pp" [checked]="data_form_for_wifi.controls.hidden.value"
                              (change)="data_form_for_wifi.controls.hidden.setValue(!data_form_for_wifi.controls.hidden.value)" />
                            <label for="ssl1_pp" class="toggle m-0"><span class="toggle_handler"></span></label>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <label class="form-label">Network Name<span class="text-danger">*</span></label>
                        <input type="text" formControlName="ssid" required class="form-control" maxlength="250"
                          [class.is-invalid]="data_form_for_wifi.get('ssid').hasError('required') && data_form_for_wifi.get('ssid').touched">
                        <ng-container *ngIf="data_form_for_wifi.get('ssid').touched">
                          <p class="input-error" *ngIf="data_form_for_wifi.get('ssid').hasError('required')">
                            Network name is required!</p>
                        </ng-container>
                      </div>

                      <div class="row g-3">
                        <div class="col-lg-7">
                          <div class="mb-3">
                            <label class="form-label">Password<span class="text-danger">*</span></label>
                            <input type="text" formControlName="password" required class="form-control" maxlength="250"
                              [class.is-invalid]="data_form_for_wifi.get('password').hasError('required') && data_form_for_wifi.get('password').touched">
                            <ng-container *ngIf="data_form_for_wifi.get('password').touched">
                              <p class="input-error" *ngIf="data_form_for_wifi.get('password').hasError('required')">
                                Password is required!</p>
                            </ng-container>
                          </div>
                        </div>
                        <div class="col-lg-5">
                          <div class="mb-3">
                            <label class="form-label">Encryption <i class="bi bi-info-circle mouse-pointer ms-1"
                                data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top"
                                title="Security protocol on your network"></i></label>
                            <ng-select appearance="outline" formControlName="encryption" [clearable]="false"
                              [searchable]="false">
                              <ng-option [value]="encryptions.NONE">None</ng-option>
                              <ng-option [value]="encryptions.WEP">{{encryptions.WEP}}</ng-option>
                              <ng-option [value]="encryptions.WPA">{{encryptions.WPA}}/{{encryptions.WPA}}2</ng-option>
                            </ng-select>
                          </div>
                        </div>
                      </div>

                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.VCARD">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_vcard" (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator && qr_generator.vcard_data">
                      <h1 class="mb-3">vCard QR Code</h1>
                      <div class="mb-3">
                        <i class="bi bi-phone me-2"></i>
                        <b>Contact Information</b>
                      </div>
                      <p>Enter your contact details. Users can save your info to their smartphone
                        address book
                        after
                        scanning or contact you right away.</p>

                      <!-- <div class="t-main-wrapper mb-4">
                                                <div class="t-header">
                                                    <div class="t-title">
                                                        <label>Contact picture <i class="bi bi-info-circle f-sm ms-1"
                                                                data-bs-toggle="tooltip" data-bs-html="true"
                                                                data-bs-placement="top"
                                                                title="Upload an image from your computer.">
                                                            </i></label>
                                                    </div>
                                                    <div class="toggleWrapper">
                                                        <input type="checkbox" id="ssl1_pp"
                                                            [checked]="data_form_for_vcard.get('show_profile_url').value"
                                                            (change)="data_form_for_vcard.get('show_profile_url').setValue(!data_form_for_vcard.get('show_profile_url').value)" />
                                                        <label for="ssl1_pp" class="toggle m-0"><span
                                                                class="toggle_handler"></span></label>
                                                    </div>
                                                </div>

                                                <div class="t-body pt-4"
                                                    *ngIf="data_form_for_vcard.get('show_profile_url').value">
                                                    <app-shared-qr-change-banner-image class="v3"
                                                        [data]="data_form_for_vcard.controls.profile_url.value"
                                                        (_change)="data_form_for_vcard.controls.profile_url.setValue($event)"
                                                        [banner_mode]="false">
                                                    </app-shared-qr-change-banner-image>
                                                </div>
                                            </div> -->

                      <div class="row g-3">
                        <div class="col-lg-12">
                          <label class="form-label">Full Name<span class="text-danger">*</span></label>
                          <input type="text" formControlName="full_name" required class="form-control" maxlength="120"
                            [class.is-invalid]="data_form_for_vcard.get('full_name').hasError('required') && data_form_for_vcard.get('full_name').touched"
                            placeholder="Please type your full name">
                          <p class="input-error"
                            *ngIf="data_form_for_vcard.get('full_name').hasError('required') && data_form_for_vcard.get('full_name').touched">
                            Full name is required!</p>
                        </div>
                        <div class="col-lg-6">
                          <label class="form-label">Email<span class="text-danger">*</span></label>
                          <input type="email" class="form-control"
                            [class.is-invalid]="(data_form_for_vcard.get('email').hasError('required') || data_form_for_vcard.get('email').hasError('email')) && data_form_for_vcard.get('email').touched"
                            formControlName="email" required placeholder="Please type your email">
                          <p class="input-error"
                            *ngIf="data_form_for_vcard.get('email').hasError('required') && data_form_for_vcard.get('email').touched">
                            Email address is required!
                          </p>
                          <p class="input-error"
                            *ngIf="data_form_for_vcard.get('email').hasError('email') && data_form_for_vcard.get('email').touched">
                            Email address is invalid!
                          </p>
                        </div>
                        <div class="col-lg-6">
                          <label class="form-label">Phone Number<span class="text-danger">*</span></label>
                          <input type="text" class="form-control"
                            [class.is-invalid]="(data_form_for_vcard.get('mobile').hasError('required') || data_form_for_vcard.get('mobile').hasError('pattern')) && data_form_for_vcard.get('mobile').touched"
                            formControlName="mobile" required placeholder="01234567891">
                          <ng-container *ngIf="data_form_for_vcard.get('mobile').touched">
                            <p class="input-error" *ngIf="data_form_for_vcard.get('mobile').hasError('required')">
                              Phone number is required!
                            </p>
                            <p class="input-error" *ngIf="data_form_for_vcard.get('mobile').hasError('pattern')">
                              Phone number format is invalid!
                            </p>
                          </ng-container>
                        </div>
                        <div class="col-lg-6">
                          <label class="form-label">Company</label>
                          <input type="text" formControlName="company_name" maxlength="120" class="form-control"
                            placeholder="Please type your company">
                        </div>
                        <div class="col-lg-6">
                          <label class="form-label">Your Job</label>
                          <input type="text" formControlName="designation" maxlength="120" class="form-control"
                            placeholder="Please type your role">
                        </div>
                        <div class="col-lg-12">
                          <label class="form-label">Website</label>
                          <input type="url" class="form-control"
                            [class.is-invalid]="data_form_for_vcard.controls['website'].errors?.pattern && data_form_for_vcard.get('website').touched"
                            formControlName="website" name="website" placeholder="http://www.my-website.com">
                          <p class="input-error"
                            *ngIf="data_form_for_vcard.controls['website'].errors?.pattern && data_form_for_vcard.get('website').touched">
                            Website address is
                            invalid!
                          </p>
                        </div>
                        <div class="col-lg-12">
                          <label class="form-label">Note</label>
                          <textarea class="form-control" formControlName="note" maxlength="60" rows="2"></textarea>
                        </div>
                      </div>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.EMAIL">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_email" (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator && qr_generator.email_data">
                      <h1 class="mb-3">Email QR Code</h1>
                      <div class="mb-3">
                        <i class="bi bi-envelope me-2"></i>
                        <b>Enter an email address</b>
                      </div>
                      <p>After scanning the QR Code, users can send an email to the address you
                        entered. You may
                        provide a subject and message they can edit before sending.</p>
                      <div class="mb-3">
                        <label class="form-label">Email<span class="text-danger">*</span></label>
                        <input type="email" class="form-control"
                          [class.is-invalid]="(data_form_for_email.get('email').hasError('required') || data_form_for_email.get('email').hasError('email')) && data_form_for_email.get('email').touched"
                          formControlName="email" required placeholder="Please type your email">
                        <p class="input-error"
                          *ngIf="data_form_for_email.get('email').hasError('required') && data_form_for_email.get('email').touched">
                          Email address is required!
                        </p>
                        <p class="input-error"
                          *ngIf="data_form_for_email.get('email').hasError('email') && data_form_for_email.get('email').touched">
                          Email address is invalid!
                        </p>

                      </div>
                      <div class="mb-3">
                        <label class="form-label">Subject<span class="text-danger">*</span></label>
                        <input type="text" formControlName="subject" class="form-control"
                          [class.is-invalid]="data_form_for_email.get('subject').hasError('required') && data_form_for_email.get('subject').touched"
                          placeholder="Email subject">
                      </div>
                      <label class="form-label">Message</label>
                      <div class="quill-editor-wrapper">
                        <textarea class="form-control" formControlName="body" maxlength="300" rows="5"
                          placeholder="Please send me some information about..."></textarea>
                      </div>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.SMS">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_sms" (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator && qr_generator.sms_data">
                      <h1 class="mb-3">SMS QR Code</h1>
                      <div class="mb-3">
                        <i class="bi bi-phone me-2"></i>
                        <b>Enter Phone Number</b>
                      </div>
                      <p>Users can send a text message to the number entered. You may provide an
                        editable message.
                      </p>
                      <div class="mb-3">
                        <label class="form-label">Mobile number<span class="text-danger">*</span></label>
                        <input type="text" class="form-control"
                          [class.is-invalid]="(data_form_for_sms.get('mobile').hasError('required') || data_form_for_sms.get('mobile').hasError('pattern')) && data_form_for_sms.get('mobile').touched"
                          formControlName="mobile" required placeholder="01234567891">
                        <ng-container *ngIf="data_form_for_sms.get('mobile').touched">
                          <p class="input-error" *ngIf="data_form_for_sms.get('mobile').hasError('required')">
                            Mobile number is required!
                          </p>
                          <p class="input-error" *ngIf="data_form_for_sms.get('mobile').hasError('pattern')">
                            Mobile number format is invalid!
                          </p>
                        </ng-container>
                      </div>
                      <label class="form-label">Message</label>
                      <div class="quill-editor-wrapper">
                        <textarea class="form-control" formControlName="body" maxlength="1000" rows="5"
                          placeholder="Sign me up to win!"></textarea>
                      </div>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.TEXT">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_text" (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator && qr_generator.text_data">
                      <h1 class="mb-3">Text</h1>
                      <div class="mb-3">
                        <i class="bi bi-chat-square me-2"></i>
                        <b>Enter Text</b>
                      </div>
                      <p>Type any message containing numbers and symbols up to 300 characters.</p>
                      <label class="form-label">Message<span class="text-danger">*</span></label>
                      <div class="quill-editor-wrapper">
                        <textarea class="form-control" formControlName="text" required maxlength="300" rows="5"
                          [class.is-invalid]="data_form_for_text.get('text').hasError('required') && data_form_for_text.get('text').touched"
                          placeholder="Sign me up to win!"></textarea>
                      </div>
                      <p class="input-error"
                        *ngIf="data_form_for_text.get('text').hasError('required') && data_form_for_text.get('text').touched">
                        Text is
                        required!</p>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.LOCATION">
                  <form #qrForm="ngForm" autocomplete="off" [formGroup]="data_form_for_location"
                    (ngSubmit)="generateQr()">
                    <div class="category-body" *ngIf="qr_generator?.location_data">
                      <h1 class="mb-1">Enter Lat & Long</h1>
                      <p class="lg">You can track scans with dynamic QR codes, more advanced
                        location search and so much
                        more, click <a routerLink="/auth/signup">here</a> to get started.</p>
                      <div class="row g-3">
                        <div class="col-lg-6">
                          <label class="form-label">Enter latitude</label>
                          <input type="number" class="form-control"
                            [class.is-invalid]="(data_form_for_location.controls.latitude.errors?.pattern || data_form_for_location.get('latitude').hasError('required')) && data_form_for_location.get('latitude').touched"
                            formControlName="latitude" name="latitude" required placeholder="0">
                          <p class="input-error"
                            *ngIf="data_form_for_location.controls.latitude.errors?.pattern && data_form_for_location.get('latitude').touched">
                            Latitude
                            is
                            invalid!
                          </p>
                          <p class="input-error"
                            *ngIf="data_form_for_location.get('latitude').hasError('required') && data_form_for_location.get('latitude').touched">
                            Latitude
                            is
                            required!</p>
                        </div>
                        <div class="col-lg-6">
                          <label class="form-label">Enter longitude</label>
                          <input type="number" class="form-control"
                            [class.is-invalid]="(data_form_for_location.controls.longitude.errors?.pattern || data_form_for_location.get('longitude').hasError('required')) && data_form_for_location.get('longitude').touched"
                            formControlName="longitude" name="longitude" required placeholder="0">
                          <p class="input-error"
                            *ngIf="data_form_for_location.controls.longitude.errors?.pattern && data_form_for_location.get('longitude').touched">
                            Longitude
                            is
                            invalid!
                          </p>
                          <p class="input-error"
                            *ngIf="data_form_for_location.get('longitude').hasError('required') && data_form_for_location.get('longitude').touched">
                            Longitude
                            is
                            required!</p>
                        </div>
                      </div>
                      <button class="btn btn-secondary btn-block mt-5" type="submit">
                        <svg width="18" height="18" fill="currentColor" class="bi bi-arrow-repeat me-1"
                          viewBox="0 0 16 16">
                          <path
                            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                          <path fill-rule="evenodd"
                            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                        </svg> GENERATE QR CODE
                      </button>
                      <ng-container *ngTemplateOutlet="useAPI"></ng-container>
                    </div>
                  </form>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.MEMORIES">
                  <div class="category-body">
                    <h1 class="title">Shared Photo Album</h1>
                    <p class="sub-title">Create lasting moments: let your <b class="text-success">guests</b>
                      capture and share
                      their memories with ease by simply scanning a QR code to upload photos and videos they took at
                      your event.
                    </p>
                    <div class="d-flex flex-row buy-now animated fadeIn">
                      <a routerLink="/products/memories" class="btn btn-success btn-sm">
                        Buy Now
                        <i class="bi bi-arrow-right ms-2"></i>
                      </a>
                      <span class="text-success">
                        Over <b>5,000</b> people like you have purchased this product!
                      </span>
                    </div>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="memories_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>

                    <!-- <ng-container *ngTemplateOutlet="getStartedOption"></ng-container> -->
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.SOCIAL_MEDIA">
                  <div class="category-body">
                    <h1 class="title">Social Media</h1>
                    <p class="sub-title">Create a reference landing page for <span>all your social handles
                        and links</span>.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="social_media_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.COUPONS">
                  <div class="category-body">
                    <h1 class="title">Coupons</h1>
                    <p class="sub-title">Here you can <span>easily create coupons</span> which your customers can
                      <span>redeem
                        and use in
                        your online or physical stores</span> to get discounts. Simply create the
                      coupon, add the details and share the QR Code with your customers.
                    </p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="coupons_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.VCARD_PRO">
                  <div class="category-body">
                    <h1 class="title">vCard Pro</h1>
                    <p class="sub-title">
                      Skip the business card shuffle! <br /> <span>Digital business cards</span> store your contact info
                      and
                      profiles, shared with a scan.
                      Easy updates, eco-friendly, and always in your pocket allowing you to share and
                      exchange contact
                      information more efficiently and effectively.
                    </p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="vcard_pro_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.PET">
                  <div class="category-body">
                    <h1 class="title">Pet</h1>
                    <p class="sub-title">
                      No more <span>lost pet worries</span>! This QR code leads to your pet's info for a quick and happy
                      reunion.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="pet_tag_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.BUSINESS_PAGE">
                  <div class="category-body">
                    <h1 class="title">Business Page</h1>
                    <p class="sub-title">Create a <span>simple business page</span> with all the important
                      information
                      for
                      your
                      customers.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="business_page_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.FEEDBACK">
                  <div class="category-body">
                    <h1 class="title">Feedbacks</h1>
                    <p class="sub-title"><span>Collect feedbacks</span> and get rated from your customers with a
                      simple link.
                      Set up your feedback page and share the link or QR code on
                      your different social platforms or as part of your follow up emails or
                      texts.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="feedback_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.RESTAURANT_MENU">
                  <div class="category-body">
                    <h1 class="title">Restaurant Menu</h1>
                    <p class="sub-title">Ditch the Menus, Embrace the Future!
                      Creating your <span>restaurant's menu is now easier than ever</span>. No more bulky binders or
                      laminated
                      sheets!
                    </p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="restaurant_menu_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.LONG_PLAIN_TEXT">
                  <div class="category-body">
                    <h1 class="title">Long Text</h1>
                    <p class="sub-title">Craft a <span>web page for lengthy text</span> with our user-friendly,
                      efficient function with simplified sharing!
                    </p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="long_plain_text_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.RATING">
                  <div class="category-body">
                    <h1 class="title">Rating</h1>
                    <p class="sub-title"><span>Request for ratings</span> from your customers after a sale or
                      service. Set this
                      up and share the created QR code or link to the concerned
                      customers.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="rating_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.VIDEOS">
                  <div class="category-body">
                    <h1 class="title">YouTube Videos</h1>
                    <p class="sub-title">Create a <span>video gallery</span> which you can share with your
                      audience
                      with a
                      simple link or QR code. This can serve as a portfolio if you’re a video
                      creator or content producer.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="videos_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.EVENT">
                  <div class="category-body">
                    <h1 class="title">Events</h1>
                    <p class="sub-title">Promote events by <span>creating an event page</span> with all important
                      information
                      like date, location, directions etc.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="events_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.VACANCY">
                  <div class="category-body">
                    <h1 class="title">Vacancies</h1>
                    <p class="sub-title">Create a vacancy page to <span>post job listings</span> for your
                      business.
                      You can
                      include all information about the job and accept applications on the
                      same page or redirect to a different application page.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="vacancies_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.PDF">
                  <div class="category-body">
                    <h1 class="title">PDF</h1>
                    <p class="sub-title"><span>Share documents with people</span> by adding it to your PDF page.
                      Your audience can easily view or download the documents from your page.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="pdf_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.APP">
                  <div class="category-body">
                    <h1 class="title">App</h1>
                    <p class="sub-title"><span>Share your mobile apps</span> here and include links to all the
                      different
                      platforms from where it can be downloaded, all the while getting
                      detailed analytics on link visits.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="app_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.MP3">
                  <div class="category-body">
                    <h1 class="title">MP3</h1>
                    <p class="sub-title"><span>Share your music</span> and MP3 files here, and include links to
                      other platforms
                      where your audience can listen or download.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="mp3_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-container *ngIf="selected_category === all_categories.IMAGES">
                  <div class="category-body">
                    <h1 class="title">Images</h1>
                    <p class="sub-title"><span>Easily share images</span> with your audience by adding them to
                      your
                      image gallery page and sharing with a single link or QR code. All the while
                      getting detailed analytics on page visits.</p>
                    <ng-container *ngTemplateOutlet="getStartedOption"></ng-container>
                    <br>
                    <hr>
                    <br>
                    <h4>Perfect for <span class="text-success ms-1"><app-txt-rotate
                          [texts]="images_uses_cases_titles"></app-txt-rotate></span></h4>
                    <app-core-product-use-cases-wrapper [qr_category]="selected_category"
                      view_type="view2"></app-core-product-use-cases-wrapper>
                  </div>
                </ng-container>

                <ng-template #getStartedOption>
                  <div class="mt-4">
                    <app-auth-google></app-auth-google>
                    <div class="mt-2 custom-text-muted">
                      or
                      <a routerLink="/auth/signup">
                        Sign up
                      </a>
                      to get started with email
                    </div>
                  </div>
                </ng-template>

                <ng-template #useAPI>
                  <!-- <div
                                        class="banner-wrapper banner-wrapper-info hidden-on-mobile my-4 d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <i class="bi bi-code-slash"></i>
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                            Automate your QR Code generation with our API
                                        </div>
                                        <a target="_blank" routerLink="/api-documentation" class="aleft me-2">See
                                            how</a>
                                        <a routerLink="/auth/signup" class="aright">Get Started</a>
                                    </div> -->

                  <div class="use-api mt-4">
                    <div class="row g-3 align-items-center">
                      <div class="col-md-8">
                        <div class="content d-flex align-items-center">
                          <div class="icon me-3">
                            <i class="bi bi-code-slash"></i>
                          </div>
                          <p class="mb-0">Automate your QR Code generation with our API</p>
                        </div>
                      </div>
                      <div class="col-md-4 text-end">
                        <button class="btn btn-outline-secondary btn-sm" target="_blank"
                          routerLink="/api-documentation">Get Started</button>
                      </div>
                    </div>
                  </div>

                </ng-template>

              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-5 pt-6 pt-lg-0 px-lg-0" *ngIf="qr_generator">
          <ng-container *ngIf="isFreeCategory(); else showPreview">
            <app-core-download-qr [selected_category]="selected_category"
              [selected_category_obs]="selected_category_obs.asObservable()">
            </app-core-download-qr>
          </ng-container>
          <ng-template #showPreview>
            <div class="sticky-top">
              <app-shared-qr-preview [show_demo]="true" [_page]="selected_category"
                [event_page]="selected_category_obs.asObservable()">
              </app-shared-qr-preview>
            </div>
          </ng-template>
        </div>
      </div>
    </section>
  </div>
</div>

<section class="easy-sharing">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <p>Easy sharing</p>
        <h1 class="lg">Share your created web pages easily with QR codes that can be scanned and accessed
          anywhere.</h1>
      </div>
      <div class="col-md-6 mt-5 mt-md-0">
        <img loading="lazy" src="assets/landing/easy-sharing.png" alt="Brand qr codes effortless set up" width="100%" />
      </div>
    </div>
  </div>
</section>

<section class="steps">
  <img loading="lazy" src="assets/landing/patern-top.png" width="30%" class="patern-top">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h1 class="double-xl text-white">Three easy <br> steps</h1>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1 class="triple-xl text-white">1.</h1><br>
        <h1 class="xl text-white">Select QR Code Type</h1>
      </div>
      <div class="col-md-6 mt-5 mt-md-0">
        <img loading="lazy" src="assets/landing/qr-type.png" alt="Brand qr codes effortless set up" width="100%" />
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1 class="triple-xl text-white">2.</h1><br>
        <h1 class="xl text-white">Add your information</h1>
      </div>
      <div class="col-md-6 mt-5 mt-md-0">
        <img loading="lazy" src="assets/landing/add-information.png" alt="Brand qr codes effortless set up"
          width="100%" />
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-md-6">
        <h1 class="triple-xl text-white">3.</h1><br>
        <h1 class="xl text-white">Design & Share QR Code</h1>
      </div>
      <div class="col-md-6 mt-5 mt-md-0">
        <img loading="lazy" src="assets/landing/design.png" alt="Brand qr codes effortless set up" width="100%" />
      </div>
    </div>
  </div>
  <img loading="lazy" src="assets/landing/patern-bottom.png" width="30%" class="patern-bottom">
</section>


<section class="useful-analytics">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h1 class="xl">Useful analytics</h1>
        <img loading="lazy" class="mt-5" src="assets/landing/analytics.png" alt="Brand qr codes effortless set up"
          width="100%" />
      </div>
    </div>
  </div>
</section>

<section class="setup">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h1 class="xl text-white mb-5">Effortless set up</h1>
        <p>Set up a business or personal web page to share anything - social media links, business menu, three
          cards, image gallery, event promotion or job listings.</p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-8">
        <img loading="lazy" src="assets/landing/web-page.png" alt="Brand qr codes effortless set up" width="100%" />
      </div>
    </div>
  </div>
  <img loading="lazy" src="assets/landing/patern-bottom.png" width="30%" class="patern-bottom">
</section>

<section class="easy-sharing">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6">
        <p>Digital to physical</p>
        <h1 class="lg">The QR code enables a seamless transition between your digital and physical platforms
        </h1>
      </div>
      <div class="col-md-6 mt-5 mt-md-0">
        <img loading="lazy" src="assets/landing/digital-physical.png" alt="Brand qr codes effortless set up"
          width="100%" />
      </div>
    </div>
  </div>
</section>

<section class="pop-up">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 text-center">
        <h1 class="xl text-white mb-5">Collect leads with <br> Pop-up forms</h1>
        <p>Easily create user-friendly pop-up forms for any of your dynamic QR codes to collect potential
          business leads.</p>
        <a class="btn btn-secondary btn-lg mb-5" routerLink="/pop-up-form">
          Learn more
          <i class="bi bi-chevron-right me-2"></i>
        </a>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-8 col-sm-10 col-10">
        <img loading="lazy" src="assets/landing/pop-up.png" alt="Brand qr codes effortless set up" width="100%" />
      </div>
    </div>
  </div>
  <img loading="lazy" src="assets/landing/patern-bottom.png" width="30%" class="patern-bottom">
</section>

<section class="features">
  <div class="container">
    <div class="row mb-5">
      <div class="col-lg-8">
        <h1 class="xl mb-5">Use BrandQRCodes to collect potential business leads</h1>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="feature-box">
          <h4>Customisable QR Codes</h4>
          <p class="lg">Create Qr codes that fit your brand or personality by customising the colours, adding
            logos and a lot more.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="feature-box">
          <h4>Tracked QR Codes</h4>
          <p class="lg">Get access to insights on how your QR code is used -  how many times it has been
            scanned, where it was scanned, when and with what type of device.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="feature-box">
          <h4>Landing page templates</h4>
          <p class="lg">Use our pre-designed templates or customise your own landing page to provide a unique
            experience when customers scan your Qr codes.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="feature-box">
          <h4>Easy set up</h4>
          <p class="lg">Generate your QR codes in simple steps. The simple interface makes it easy to set up
            and share without any prior experience.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="feature-box">
          <h4>Dynamic and static QR Codes</h4>
          <p class="lg">Create dynamic QR codes with content that can be edited or updated anytime without
            generating a new code, or choose a static one that points to a singular content</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="feature-box">
          <h4>Targeted Lead Capture</h4>
          <p class="lg">Configure your pop-up form to match specific criteria to target relevant potential leads
            interested in that particular campaign or product.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
<app-shared-bounce-modal></app-shared-bounce-modal>